//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";
import { RuleListModel } from './RuleListModel';
  
  
export class RuleCommonParameterModel extends ModelBase {
    static readonly $typeName = 'RuleCommonParameterModel';
  public dataSetName: string;
  public rule: RuleListModel;
  public comparisonDate: string;
  public effectiveDate: Date;
  public expirationDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/businessRule/models/RuleCommonParameterModel.ts